import { Button, Dropdown, Typography } from "@repo/design-system";
import type { IMetadata } from "@/api/molecularData";

const PAGE_SIZE_OPTIONS = [
  { value: "50", label: "50 rows" },
  { value: "100", label: "100 rows" },
  { value: "500", label: "500 rows" },
];

interface IPaginationFooterProps {
  metadata: IMetadata;
  pageSize: number;
  onPageSizeChange: (val: unknown) => void;
  onPrevPage: () => void;
  onNextPage: () => void;
}

export function PaginationFooter({
  metadata,
  pageSize,
  onPageSizeChange,
  onPrevPage,
  onNextPage,
}: IPaginationFooterProps) {
  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-3">
      <Typography
        variant="paragraph-m-regular"
        className="text-contentSecondary">
        {metadata.pageCount > 1
          ? `Page ${metadata.page} of ${metadata.pageCount}`
          : `${metadata.total.toLocaleString()} rows`}
      </Typography>

      <div className="ms-auto flex flex-wrap items-center gap-3">
        {/* Page size selector */}
        <div className="flex items-center gap-2">
          <Typography
            variant="paragraph-m-regular"
            className="whitespace-nowrap text-contentSecondary">
            Rows per page
          </Typography>
          <div className="w-36">
            <Dropdown
              options={PAGE_SIZE_OPTIONS}
              value={
                PAGE_SIZE_OPTIONS.find((o) => o.value === String(pageSize)) ??
                PAGE_SIZE_OPTIONS[0]
              }
              onChange={onPageSizeChange}
              isClearable={false}
              isSearchable={false}
            />
          </div>
        </div>

        {/* Prev / Next — only when multiple pages */}
        {metadata.pageCount > 1 && (
          <>
            <Button
              variant="secondary"
              size="small"
              leftIcon="arrow-left"
              isDisabled={metadata.page <= 1}
              onPress={onPrevPage}>
              Previous
            </Button>
            <Button
              variant="secondary"
              size="small"
              rightIcon="arrow-right"
              isDisabled={metadata.page >= metadata.pageCount}
              onPress={onNextPage}>
              Next
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
